import React from 'react';
import {View} from 'react-native';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {earnedDaysUtil} from '/component/partial/report/EarnedCABDays/EarnedDays.util';
import {Reports} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './QsbEarnedDaysEgo.style';

interface QsbEarnedDaysEgoProps {
  item: {
    earnedQsbOn?: any;
  };
}

export const QsbEarnedDaysEgo: React.FC<QsbEarnedDaysEgoProps> = ({item}) => {
  const {tt} = useTranslation('report.record.qsbEarnedDaysAgo');
  const earnedQsbOn = get(item, 'earnedQsbOn', {});

  return (
    <View style={styles.inline}>
      <Text testID={Reports.reportQsbEarnedDaysAgo}>
        {tt('earnedCabDays', 'Earned')}{' '}
        {earnedDaysUtil({earnedOn: earnedQsbOn, tt})}
      </Text>
    </View>
  );
};
